export const FilterNotApplicable = (value: string) => {
  return value === 'NotApplicable' ? '' : value;
};
